export const ErrorTypes: Record<
  string,
  { id: string; defaultMessage: string }
> = {
  authentication_failed: {
    id: 'authenticationFailed',
    defaultMessage: 'Authentication failed',
  },
  authorization_failed: {
    id: 'authorizationFailed',
    defaultMessage: 'Authorization failed',
  },
  auth_api_error: {
    id: 'authApiError',
    defaultMessage: 'Authentication API error',
  },
  auth0_configuration_error: {
    id: 'auth0ConfigurationError',
    defaultMessage: 'Auth0 configuration error',
  },
  auth0_authentication_failed: {
    id: 'auth0AuthenticationFailed',
    defaultMessage: 'Auth0 authentication failed',
  },
  auth0_management_error: {
    id: 'auth0ManagementError',
    defaultMessage: 'Auth0 management API error',
  },
  user_not_found: {
    id: 'userNotFound',
    defaultMessage: 'User not found',
  },
  user_already_exists: {
    id: 'userAlreadyExists',
    defaultMessage: 'User already exists',
  },
  user_inactive: {
    id: 'userInactive',
    defaultMessage: 'User account is disabled',
  },
  email_verification_required: {
    id: 'emailVerificationRequired',
    defaultMessage: 'Email verification required',
  },
  token_validation_failed: {
    id: 'tokenValidationFailed',
    defaultMessage: 'Token validation failed',
  },
  token_expired: {
    id: 'tokenExpired',
    defaultMessage: 'Token has expired',
  },
  invalid_token: {
    id: 'invalidToken',
    defaultMessage: 'Invalid token',
  },
  bad_request: {
    id: 'badRequest',
    defaultMessage: 'Invalid request parameters or body',
  },
  unauthorized: {
    id: 'unauthorized',
    defaultMessage: 'Authentication required or failed',
  },
  forbidden: {
    id: 'forbidden',
    defaultMessage: 'Insufficient permissions',
  },
  not_found: {
    id: 'notFound',
    defaultMessage: 'Resource not found',
  },
  conflict: {
    id: 'conflict',
    defaultMessage: 'Resource conflict (e.g., duplicate entry)',
  },
  validation_error: {
    id: 'validationError',
    defaultMessage: 'Request validation failed',
  },
  rate_limit_exceeded: {
    id: 'rateLimitExceeded',
    defaultMessage: 'Too many requests',
  },
  internal_server_error: {
    id: 'internalServerError',
    defaultMessage: 'Unexpected server error',
  },
  service_unavailable: {
    id: 'serviceUnavailable',
    defaultMessage: 'External service unavailable',
  },
};
